import React, { Component } from "react";
import ReactStars from "react-rating-stars-component";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import logo from "../../assets/logo.png";

export default class Feedback extends Component {
  state = {
    staff: 0,
    service: 0,
    clean: 0,
    comment: "",
    contact: "",
    sendFeedback: false,
    redirect: false,
  };

  constructor(props) {
    super(props);
    this.sendFeedback = this.sendFeedback.bind(this);
  }

  handleLanguageChange = async (e) => {
    await this.props.handleLangaugeSubmit(e);
    this.layoutDirection();
  };

  layoutDirection() {
    if (this.props.Language != "en")
      document.getElementById("feedbackId").style.direction = "rtl";
    else document.getElementById("feedbackId").style.direction = "ltr";
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  async sendFeedback() {
    const { data } = await axios.post(
      "https://manage.caviarmenu.com/api/feedback",
      {
        username: this.props.Settings.username,
        service: this.state.service,
        staff: this.state.staff,
        clean: this.state.clean,
        comment: this.state.comment,
        contact: this.state.contact,
      }
    );

    if (data.status) {
      this.setState({ sendFeedback: true });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    }
  }

  render() {
    return this.state.redirect ? (
      <Navigate to="/" replace={true} />
    ) : (
      <div className="feedback-page ani-fade-in-s">
        <div className="head-feedback">
          {/*  */}
          <Link to={"/menu/600"}>
            {/* <img src={backArrow} className="backward" alt="" /> */}
            <svg
              width="22"
              height="24"
              viewBox="0 0 22 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.10156 11.6953L1.22656 0.0761719H5.04102L11 9.42773L17.2402 0.0761719H20.791L12.8809 11.6953L21.3008 24H17.416L10.9648 14.1211L4.33789 24H0.751953L9.10156 11.6953Z"
                fill="white"
              />
            </svg>
          </Link>

          {/* <div className="language"></div> */}
        </div>
        {/* <div className="language" style={{ padding: "0 0.75rem" }}>
          <button
            type="submit"
            className={this.props.Language == "krd" ? "activ" : ""}
            onClick={() => this.handleLanguageChange("krd")}
          >
            {" "}
            کوردی{" "}
          </button>
          <div className="lanLine"></div>
          <button
            type="submit"
            className={
              "englishBtn " + (this.props.Language == "en" ? "activ" : "")
            }
            onClick={() => this.handleLanguageChange("en")}
          >
            {" "}
            English{" "}
          </button>
          <div className="lanLine"></div>

          <button
            type="submit"
            className={this.props.Language == "ar" ? "activ" : ""}
            onClick={() => this.handleLanguageChange("ar")}
          >
            {" "}
            عربی{" "}
          </button>
        </div> */}
        {this.state.sendFeedback ? (
          <div
            className="feedback-success-message"
            style={
              this.props.Language === "krd"
                ? { fontFamily: "UniSIRWAN Somar" }
                : {}
            }
          >
            {this.props.Language == "en"
              ? "Thank you for your feedback! We appreciate your input and will use it to improve."
              : this.props.Language == "krd"
              ? "سوپاس بۆ بۆچوون و تێبینیێن هەوە، بلند دنرخینین و ژ بۆ باشتربوون و پێشڤەچوونێ دێ بکارهینین."
              : "نشكرك على ملاحظاتك! نقدر مشاركتك وسنستخدمها لتحسين الأمور."}
          </div>
        ) : (
          <div
            className="feedback"
            id="feedbackId"
            style={
              this.props.Language === "krd"
                ? { fontFamily: "UniSIRWAN Somar" }
                : {}
            }
          >
            <img src={logo} className="logo" alt="" />
            <h1>
              {this.props.Language == "en"
                ? "Your Opinion Matters!"
                : this.props.Language == "krd"
                ? " رەیئیا تە یا گرنگە!"
                : "مراجعة"}
            </h1>

            <div className="feedback-container">
              <div className="feedback-item">
                <div className="title">
                  {this.props.Language == "en"
                    ? "Staff Rating"
                    : this.props.Language == "krd"
                    ? "هەڵسەنگاندنا کارمەدان"
                    : "تقييم طاقم عمل"}
                </div>
                <div className="rating">
                  <ReactStars
                    count={5}
                    onChange={(val) => this.setState({ staff: val })}
                    size={25}
                    value={this.state.staff}
                    activeColor="#ffffff"
                    color="#ffffff00"
                    emptyIcon={
                      <FaStar
                        style={{
                          marginRight: "4px",
                          stroke: "#ffffff",
                          strokeWidth: 20,
                          fill: "transparent",
                        }}
                      />
                    }
                    filledIcon={
                      <FaStar
                        style={{
                          marginRight: "4px",
                          color: "#ffffff",
                          stroke: "#ffffff",
                          strokeWidth: 0,
                        }}
                      />
                    }
                  />
                </div>
              </div>

              <div className="feedback-item">
                <div className="title">
                  {this.props.Language == "en"
                    ? "Service Rating"
                    : this.props.Language == "krd"
                    ? "هەڵسەنگاندنا خزمەتگۆزاریێ"
                    : "تقييم الخدمات"}
                </div>
                <div className="rating">
                  <ReactStars
                    count={5}
                    onChange={(val) => this.setState({ service: val })}
                    size={25}
                    value={this.state.staff}
                    activeColor="#ffffff"
                    color="#ffffff00"
                    emptyIcon={
                      <FaStar
                        style={{
                          marginRight: "4px",
                          stroke: "#ffffff",
                          strokeWidth: 20,
                          fill: "transparent",
                        }}
                      />
                    }
                    filledIcon={
                      <FaStar
                        style={{
                          marginRight: "4px",
                          color: "#ffffff",
                          stroke: "#ffffff",
                          strokeWidth: 0,
                        }}
                      />
                    }
                  />
                </div>
              </div>

              <div className="feedback-item">
                <div className="title">
                  {this.props.Language == "en"
                    ? "Clean Rating"
                    : this.props.Language == "krd"
                    ? "هەڵسەنگاندنا پاقژیێ"
                    : " تقييم النظافة"}
                </div>
                <div className="rating">
                  <ReactStars
                    count={5}
                    onChange={(val) => this.setState({ clean: val })}
                    size={25}
                    value={this.state.staff}
                    activeColor="#ffffff"
                    color="#ffffff00"
                    emptyIcon={
                      <FaStar
                        style={{
                          marginRight: "4px",
                          stroke: "#ffffff",
                          strokeWidth: 20,
                          fill: "transparent",
                        }}
                      />
                    }
                    filledIcon={
                      <FaStar
                        style={{
                          marginRight: "4px",
                          color: "#ffffff",
                          stroke: "#ffffff",
                          strokeWidth: 0,
                        }}
                      />
                    }
                  />
                </div>
              </div>

              <div
                className="feedback-item"
                style={{ flexDirection: "column", gap: "0rem" }}
              >
                <div
                  className="title"
                  style={{ width: "70%", textAlign: "start", fontSize: "1rem" }}
                >
                  {this.props.Language == "en"
                    ? "Additional Feedback"
                    : this.props.Language == "krd"
                    ? "تێبینی یان پێشنیار"
                    : "تعليقك يهمنا"}
                </div>
                <div
                  className="Comment"
                  style={
                    this.props.Language == "en"
                      ? { direction: "ltr" }
                      : { direction: "rtl" }
                  }
                >
                  <textarea
                    name="comment"
                    style={
                      this.props.Language !== "en"
                        ? { fontFamily: "UniSIRWAN Somar" }
                        : this.props.Language === "en"
                        ? { fontFamily: "UniSIRWAN Somar" }
                        : {}
                    }
                    placeholder={
                      this.props.Language == "en"
                        ? "What else would you like us to know?"
                        : this.props.Language == "krd"
                        ? "تێبینی یان پێشنیارەکا دی تە هەیە؟"
                        : "ما الذي تود إخبارنا به أيضًا؟"
                    }
                    onChange={this.handleChange}
                  ></textarea>
                </div>
              </div>

              <div
                className="feedback-item"
                style={{ marginTop: "3rem", gap: "0rem" }}
              >
                <div className="field">
                  <input
                    className="contact-input"
                    type="text"
                    name="contact"
                    style={{
                      fontFamily:
                        this.props.Language !== "en"
                          ? "UniSIRWAN Somar"
                          : this.props.Language === "en"
                          ? "UniSIRWAN Somar"
                          : undefined,
                      direction: this.props.Language === "en" ? "ltr" : "rtl",
                    }}
                    placeholder={
                      this.props.Language == "en"
                        ? "Phone / Email:"
                        : this.props.Language == "krd"
                        ? "ژمارا تلوفوونێ / ئێمێل:"
                        : "رقم الهاتف / البريد الإلكتروني:"
                    }
                    onChange={this.handleChange}
                  />
                </div>
                <button
                  onClick={this.sendFeedback}
                  style={
                    this.props.Language !== "en"
                      ? { fontFamily: "UniSIRWAN Somar" }
                      : this.props.Language === "en"
                      ? { fontFamily: "UniSIRWAN Somar" }
                      : {}
                  }
                >
                  {this.props.Language == "en"
                    ? "Send"
                    : this.props.Language == "krd"
                    ? "هنارتن"
                    : "ارسال"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
